import React, {useState, useEffect, useRef} from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import CardContent from '@material-ui/core/CardContent';
import { styles } from '../../styles/card-styles';
import MainCardContent from './MainCardContent';
import DetailsCardContent from './DetailsCardContent';

function ChartCardContentContainer(props) {
  const { classes, data, unit, alerts, rangeSetting } = props;
  return (
        <CardContent classes={{root: classes.cardContent}}>
          {props.panel === "card"
            ? <MainCardContent 
              data={data} 
              unit={unit} 
              alerts={alerts} 
              rangeSetting={rangeSetting} 
              chartProps={props} />
            : <DetailsCardContent 
              data={data} 
              unit={unit} 
              alerts={alerts} 
              rangeSetting={rangeSetting} 
              chartProps={props} />
          }
          
        </CardContent>
  );
}


ChartCardContentContainer.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(ChartCardContentContainer);


// WEBPACK FOOTER //
// ./src/components/ChartCard/ChartCardContentContainer.js